module.exports = __webpack_public_path__ + "static/media/blog7.0386378c.jpg";